import { UniButton } from '@/design-system/components/buttons';
import { H6, TextBody, TextCaption, TextTitle } from '@/design-system/components/typography';
import { SxProp, View, useDripsyTheme } from 'dripsy';
import _ from 'lodash';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Icon } from '@/design-system/components/icons/Icon';
import { MobileNo } from '@/features/account-management/types';
import { Row } from '@/design-system/components/layout';
import { Card } from '@utx/utx-access-client';
import { PageHeaderModalNative } from '@/features/account-management/screens/page/PageHeaderModalNative';
import { useNavigation } from '@react-navigation/native';
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import { UpdateMobileNoStackParamList } from '@/features/account-management/screens/update-mobile-no/type';
import moment from 'moment-timezone';

export interface UpdateMobileNoProps {
  onClose: () => void;
  data: MobileNo;
  onLayout: (event: any) => void;
  returnData?: any;
  refresh?: () => void;
  record?: Card;
}

export const UpdateMobileNoNativeTwoScreen: React.FC<UpdateMobileNoProps> = (props) => {
  const { onClose, data, onLayout, returnData, refresh } = props;
  const { t } = useTranslation('account-management');
  const {
    topHeader,
    body,
    horizontalWrapper,
    textLabel,
    textDebitAmount,
    textTitle,
    textAtmPin,
    timeView,
    refView,
    textHeaderTitle,
    textHeaderSubTitle,
    btn,
    modal
  } = sxStyles;

  const { theme } = useDripsyTheme();

  const navigation = useNavigation<NativeStackNavigationProp<UpdateMobileNoStackParamList>>();
  const [instructionTime, setInstructionTime] = useState(moment().format('YYYY-MM-DD HH:mm:ss'));

  return (
    <View sx={{ height: '100%', backgroundColor: '$white' }}>
      <PageHeaderModalNative>
        <Row sx={{ justifyContent: 'center', alignItems: 'center', px: '$4', mt: '$5', mb: '$4' }}>
          <View sx={{ textAlign: 'center' }}>
            <TextTitle bold sx={{ color: theme?.colors?.$white as string }}>
              {t('card-account-management::replace-card.title--update-mobile-number')}
            </TextTitle>
          </View>
        </Row>
      </PageHeaderModalNative>
      <View sx={modal}>
        <View sx={topHeader}>
          <Icon name="checkCircleBlue" height={90} width={90} />
          <H6 bold sx={textHeaderTitle}>
            {t('card-account-management::replace-card.title--update-mobile-number-placed')}
          </H6>
          <TextCaption sx={textHeaderSubTitle}>{t('card-account-management::replace-card.text--mobile-number-updated')}</TextCaption>
        </View>
        <View sx={body}>
          <TextCaption sx={textTitle} semiBold>
            {t('card-account-management::replace-card.text--new-mobile-number')}
          </TextCaption>
          <H6 sx={textAtmPin}>
            +{data?.phoneCode} {data?.phoneNumber}
          </H6>
          <View
            sx={{
              ...horizontalWrapper,
              ...timeView
            }}>
            <TextBody sx={textLabel}>{t('card-account-management::glossary.instruction-time')}</TextBody>
            <TextBody sx={textDebitAmount}>{returnData?.instructionTime || instructionTime || '-'}</TextBody>
          </View>
          <UniButton
            sx={btn}
            label={t('card-account-management::lock-card.button--return')}
            onPress={() => {
              refresh && refresh();
              navigation.getParent()?.goBack();
            }}
          />
        </View>
      </View>
    </View>
  );
};

const sxStyles: Record<string, SxProp> = {
  modal: {
    px: '$4',
    py: '$5'
  },
  topHeader: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    background: 'primaryDefault',
    paddingBottom: '$10',
    gap: '$2'
  },
  body: {},
  horizontalWrapper: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center'
  },
  textLabel: {
    color: '$textSecondary'
  },
  textDebitAmount: {
    mb: '$1',
    color: '$textPrimary'
  },
  textTitle: {
    marginBottom: 4,
    color: '$textSecondary'
  },
  textAtmPin: {
    fontWeight: 'bolder',
    color: '$textThemeSecondary'
  },
  timeView: {
    mb: '$3',
    mt: '$5'
  },
  refView: {
    mb: '$10'
  },
  textHeaderTitle: {
    mb: '$2',
    textAlign: 'center'
  },
  textHeaderSubTitle: {
    color: '$textPrimary'
  },
  btn: {
    height: 44,
    width: '92%',
    position: 'fixed',
    left: 0,
    bottom: 0,
    marginX: 15,
    marginBottom: 30
  }
};
